import {css} from '@mui/material';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {mixins} from 'src/js/common/jsStyles/mixins';
import {GetStylesFunction, LabelValue} from 'src/js/common/types';
import {TranslateUtils} from 'src/js/common/utils';
import {DlMuiTypography} from 'src/js/components/DlMuiTypography';
import {DLSelect} from 'src/js/components/DLSelect';
import {LanguageConfig} from 'src/js/model/i18n_config';

import styles from './LanguageSwitcher.less';

const I18N = defineMessages({
  LABEL: {
    id: 'language.label',
    defaultMessage: 'Language',
    description: 'Language select label',
  },
});

type LanguageSelectOption = LabelValue<string | undefined>;

interface OptionsState {
  options?: LanguageSelectOption[];
}

interface OwnProps {
  languages?: LanguageConfig[];
  onLocaleChange: (value: string) => void;
  selectedLocale: string;
}

type Props = OwnProps;

export const LanguageSwitcher: React.FC<Props> = (props) => {
  const {onLocaleChange, selectedLocale = '', languages} = props;
  const intl = useIntl();

  const muiStyles = getStyles();

  const [options, setOptions] = useState<OptionsState>({options: undefined});

  useEffect(() => languages && setOptionsFunction(languages), [languages]);

  const handleChange = (locale: LanguageSelectOption) => {
    const ownValue = locale ? locale.value : null;
    if (ownValue) {
      onLocaleChange(ownValue);
    }
  };

  const setOptionsFunction = (languages: LanguageConfig[]) => {
    let options: LanguageSelectOption[] = [];
    if (languages) {
      options = languages.map((lang) => ({
        value: lang.getLocale(),
        label: lang.getLabel(),
      }));
    }
    setOptions({options});
  };

  return (
    <div className={styles.dlLanguageSwitcherWrapper}>
      <DlMuiTypography
        inputCss={muiStyles.dlLanguageLabel}
        title={TranslateUtils.translate(I18N.LABEL, intl)}
        data-name={'label'}
        value={`${TranslateUtils.translate(I18N.LABEL, intl)} :`}
      />
      <DLSelect className={styles.dlLanguageSwitcher} options={options.options} selectedValue={selectedLocale} onChange={handleChange} />
    </div>
  );
};

LanguageSwitcher.displayName = 'LanguageSwitcher';

const getStyles: GetStylesFunction = (_options) => ({
  dlLanguageLabel: css(
    {
      marginRight: 'var(--dlPaddingSmall)',
      flex: 'var(--dlLanguageLabelFlex)',
    },
    mixins.dlFlexBoxContainerInContainer
  ),
});
